import { ChartBellCurveIcon } from './ChartBellCurveIcon';

/**
 * author: Michael Irigoyen
 * id 35760CC7-EBA2-4445-B88B-7E8224535BB7
 * name chart-bell-curve
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bell-curve.svg
 * tags
 * - Math 
 */
export const GraphBellCurveIcon = ChartBellCurveIcon;
export default GraphBellCurveIcon